/* eslint-disable no-param-reassign */
/* eslint-disable import/no-unresolved */
import { createAction, createReducer } from 'utils/reducer';

// Local constants
const PATH = 'fruits/';
const DISABLE_ERRORS = `${PATH}DISABLE_ERRORS`;
const TOGGLE_FORM = `${PATH}TOGGLE_FORM`;
const CHANGE_CONTROLS = `${PATH}CHANGE_CONTROLS`;
const TOGGLE_DELETE = `${PATH}TOGGLE_DELETE`;
const TOGGLE_EDIT_FRUIT = `${PATH}TOGGLE_EDIT_FRUIT`;
const SET_INVALID_CONTROLS = `${PATH}SET_INVALID_CONTROLS`;

// Global constants for saga
export const FRUITS = {
  CREATE_FRUIT: `${PATH}CREATE_FRUIT`,
  CREATE_FRUIT_SUCCESS: `${PATH}CREATE_FRUIT_SUCCESS`,
  GET_STATE_FROM_API: `${PATH}GET_STATE_FROM_API`,
  GET_STATE_FROM_API_SUCCESS: `${PATH}GET_STATE_FROM_API_SUCCESS`,
  DELETE_FRUIT: `${PATH}DELETE_FRUIT`,
  DELETE_FRUIT_SUCCESS: `${PATH}DELETE_FRUIT_SUCCESS`,
  EDIT_FRUIT_SUCCESS: `${PATH}EDIT_FRUIT_SUCCESS`,
  EDIT_FRUIT: `${PATH}EDIT_FRUIT`,
  EXPORT_FRUIT: `${PATH}EXPORT_FRUIT`,
  EXPORT_FRUIT_SUCCESS: `${PATH}EXPORT_FRUIT_SUCCESS`,
};

// actions
export const fruitsActions = {
  disableErrors: createAction(DISABLE_ERRORS),
  toggleForm: createAction(TOGGLE_FORM, 'modal'),
  changeControls: createAction(CHANGE_CONTROLS, 'controls', 'invalidControls'),
  toggleDelete: createAction(TOGGLE_DELETE, 'id'),
  toggleEdit: createAction(TOGGLE_EDIT_FRUIT, 'item'),
  setInvalidControls: createAction(SET_INVALID_CONTROLS, 'controls'),
  // api
  getStateFromApi: createAction(FRUITS.GET_STATE_FROM_API),
  createFruit: createAction(FRUITS.CREATE_FRUIT, 'controls'),
  editFruit: createAction(FRUITS.EDIT_FRUIT, 'id', 'controls'),
  deleteFruit: createAction(FRUITS.DELETE_FRUIT, 'id'),

  exportFruits: createAction(FRUITS.EXPORT_FRUIT),
};

const defaultInvalidInputs = {
  name: false,
};

const initialState = {
  formControls: {
    name: '',
  },
  invalidControls: {
    name: false,
  },
  formIsOpen: false,
  deleteIsOpen: false,
  toDeleteId: '',
  toEditId: '',
  edit: false,
  error: false,
};

const fruits = createReducer(initialState, {
  [DISABLE_ERRORS](state, action) {
    state.error = false;
  },
  [TOGGLE_FORM](state, action) {
    state[action.modal] = !state[action.modal];
    state.edit = false;
    state.formControls.name = '';
    state.invalidControls = { ...defaultInvalidInputs };
  },
  [CHANGE_CONTROLS](state, action) {
    state.formControls = {
      ...state.formControls,
      ...action.controls,
    };
    state.invalidControls = {
      ...state.invalidControls,
      ...(action.invalidControls || {}),
    };
  },
  [TOGGLE_DELETE](state, action) {
    state.deleteIsOpen = !state.deleteIsOpen;
    state.toDeleteId = action.id;
  },
  [TOGGLE_EDIT_FRUIT](state, action) {
    state.formIsOpen = true;
    state.toDeleteId = '';
    state.toEditId = action.item.id;
    state.formControls.name = action.item.name;
    state.edit = true;
  },
  [SET_INVALID_CONTROLS](state, action) {
    state.invalidControls = {
      ...state.invalidControls,
      ...action.controls,
    };
  },
  // api
  [FRUITS.CREATE_FRUIT_SUCCESS](state, action) {
    state.formIsOpen = false;
    state.formControls.name = '';
    state.invalidControls = { ...defaultInvalidInputs };
  },
  [FRUITS.DELETE_FRUIT_SUCCESS](state, action) {
    state.deleteIsOpen = false;
    state.toDeleteId = '';
  },
  [FRUITS.EDIT_FRUIT_SUCCESS](state, action) {
    state.formControls.name = '';
    state.invalidControls = { ...defaultInvalidInputs };
    state.formIsOpen = false;
    state.toDeleteId = '';
    state.toEditId = '';
    state.edit = false;
  },
});

export default fruits;
